import { change } from 'redux-form';
import types from './types';
import store from '../../../config/redux/store';
import { asyncGet } from '../../../config/rest/async-action-creator';

export default {
  fetchSearchFilters: (customStore) => asyncGet(
    customStore || store,
    types.FETCH_SEARCH_FILTERS,
    'search-filters',
  ),
  fetchSeoData: (slug, customStore) => asyncGet(
    customStore || store,
    types.FETCH_SEO_DATA,
    `custom-page/${slug}`,
  ),
  fetchSearchResults: (query, customStore) => asyncGet(
    customStore || store,
    types.FETCH_SEARCH_RESULTS,
    `custom-search${query}`,
  ),
  fetchMoreSearchResults: (query) => asyncGet(
    store,
    types.FETCH_MORE_SEARCH_RESULTS,
    `custom-search${query}`,
  ),
  changeFieldsValues: (name, value) => (
    change('search', name, value)
  ),
};



// WEBPACK FOOTER //
// ./src/app/actions/search/index.js